import { render, staticRenderFns } from "./lbil-linkage-blurb-popup.html?vue&type=template&id=f5a0605e&scoped=true&external"
import script from "./lbil-linkage-blurb-popup.js?vue&type=script&lang=js&external"
export * from "./lbil-linkage-blurb-popup.js?vue&type=script&lang=js&external"
import style0 from "./lbil-linkage-blurb-popup.scss?vue&type=style&index=0&id=f5a0605e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a0605e",
  null
  
)

export default component.exports